/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {KnotSwitchCardRequest} from '@cash-web/protos/squareup/cash/postcard/app/KnotApi.pb'
import {KnotSwitchCardResponse} from '@cash-web/protos/squareup/cash/postcard/app/KnotApi.pb'


export const knotSwitchCard = (request: KnotSwitchCardRequest, options?: CashRequestOptions) => post<KnotSwitchCardRequest, KnotSwitchCardResponse>("/2.0/cash/knot-switch-card", request, {...options, rejectOnError: true })